import { render, staticRenderFns } from "./Debtorsagreementplans.vue?vue&type=template&id=19e9b07c&"
import script from "./Debtorsagreementplans.vue?vue&type=script&lang=js&"
export * from "./Debtorsagreementplans.vue?vue&type=script&lang=js&"
import style0 from "./Debtorsagreementplans.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports